import microuniversoApi from "app/api/microuniversoApi";
import {
    DadosEnviarEmail,
    anexosEnviar,
} from "app/types/modalImprimir/ModalEnviarEmail";
import {
    RespostaModalEnviarEmail,
    RespostaModalEnviarWhatsapp,
    RespostaModalImprimir,
    payloadEnviarEmail,
    payloadEnviarWhatsapp,
} from "app/types/modalImprimir/RespostaModalImprimir";
import globalMU from "globalMU";
import React, { memo, useCallback, useEffect, useState } from "react";
import { ParametrosTemplate, montarUrl } from "../modalImprimirContainer";
import { ModalEnviarWhatsapp, RemetenteWhatsapp } from "./modalEnviarWhatsapp";
import { Parametro, ParametroPorItem } from "../../../../../types/Parametro";
import { DadosEnviarWhatsapp } from "app/types/modalImprimir/DadosEnviarWhatsapp";
import { useAppSelector } from "app/redux/hooks";
import { IOrcamento } from "app/types/IOrcamento";
import { Vendedor } from "app/types/Vendedor";

import { VendedorApi } from "app/api/classes/VendedorApi";
import { StatusWhatsappResponse } from "app/types/Whatsapp/StatusWhatsappResponse";
import { ModalConfigurarWhatsapp } from "app/components/modalConfigurarWhatsapp/modalConfigurarWhatsapp";
import { ModalConfigurarWhatsappContainer } from "app/components/modalConfigurarWhatsapp/modalConfigurarWhatsappContainer";
import { EnviarWhatsappOutput } from "app/types/Whatsapp/EnviarWhatsappOutput";
import { obterParametros, obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";
import { EnumTiposMuWhatsapp } from "app/types/Whatsapp/EnumTiposMuWhatsapp";
import { DadosEnviarWhatsappMuWhatsappApi } from "app/types/modalImprimir/DadosEnviarWhatsappMuWhatsappApi";
import { ErroDaApiEnterprise } from "app/api/classes/ErroDaApiEnterprise";
import { tratamentoErroPadrao } from "app/use-cases/tratamentoErroPadrao";
import { Loading } from "app/components/Loading/Loading";
//import {obterParametros} from "../../../../../use-cases/parametro/obterParametros";

export type ModalEnviarWhatsappContainerProps = {
    exibirModalWhatsapp: boolean;
    template: RespostaModalImprimir;
    idOrcamento: number;
    permitidoAnexar: boolean;
    permitidoCopia: boolean;
    permitidoCopiaOculta: boolean;
    permitidoAlterarAssunto: boolean;
    permitidoAlterarMensagem: boolean;
    parametrosTemplate: ParametrosTemplate[];
    vendedor?: Vendedor;
    vendedorAutenticado: Vendedor;

    onClose: () => void;
    dadosEnvio?: RespostaModalEnviarEmail;
};

export const ModalEnviarWhatsappContainer = memo((
    props: ModalEnviarWhatsappContainerProps
) => {
    const [vendedorAutenticado, setVendedorAutenticado] = useState<Vendedor>(null);
    const [dadosEnviarWhatsapp, setDadosEnviarWhatsapp] = useState<RespostaModalEnviarEmail>(props.dadosEnvio);
    const [listaAnexos, setListaAnexos] = useState([]);
    const [urlTemplate, setUrlTemplate] = useState<string>("");
    const [numeroSincronizadoWhatsappVendedor, setNumeroSincronizadoWhatsappVendedor] = useState<string>("");
   
    const [ListaTelefoneCopia, setListaTelefoneCopia] = useState<string>("");
    const [statusSessaoVendedor, setStatusSessaoVendedor] = useState<StatusWhatsappResponse>(null);
    const [statusSessaoPadrao, setStatusSessaoPadrao] = useState<StatusWhatsappResponse>(null);
    const [statusSessaoFilial, setStatusSessaoFilial] = useState<StatusWhatsappResponse>(null);


    const [remetenteWhatsapp, setRemetenteWhatsapp] = useState<RemetenteWhatsapp>("padrao");
    const [versaoApiEnterprise, setVersaoApiEnterprise] = useState<string>("");
    const [abrirModalConfigurarWhatsapp, setAbrirModalConfigurarWhatsapp] = useState<boolean>(false);
    const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([]);
    const [parametrosPorEmpresa, setParametrosPorEmpresa] = useState<Parametro[]>([]);

    const [semaforoLoading, setSemaforoLoading] = useState(0);

    const mostrarLoading = useCallback(() => {
        setSemaforoLoading(v => v + 1);
    }, []);
    const esconderLoading = useCallback(() => {
        setSemaforoLoading(v => Math.max(0, v - 1));
    }, []);

    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);

    const converterVersaoParaNumero = (versao: string): number => {
        if (!versao || versao.split(".").length < 3) {
            
            return 0;
        }
        const partes = versao.split(".").map(Number);
        return partes.reduce(
            (acc, parte, index) => acc + parte * Math.pow(10, 2 - index),
            0
        );
    };
    const removerWhatsappVendedor = async (inibirMensagemDeErro?:boolean) => {
        try {
            mostrarLoading
            globalMU.blockUI();
            const resposta =
                await microuniversoApi.Whatsapp.removerWhatsappVendedor(
                    props.vendedorAutenticado?.Codigo
                );
            setNumeroSincronizadoWhatsappVendedor("");
            setStatusSessaoVendedor(null);

            if (resposta) {
                if(!inibirMensagemDeErro) {
                    globalMU.showSuccessMessage("Sessão WhatsApp anterior removida com sucesso!");
                }
                await obterInformacoesWhatsappVendedor();
            }
            setRemetenteWhatsapp("padrao");
            globalMU.sessionStorage.setData(
                "remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo, "padrao"
            );
        } catch (error) {

            if (!inibirMensagemDeErro) {
                globalMU.showErrorMessage((error as ErroDaApiEnterprise)?.mensagem ?? "Erro desconhecido ao remover o WhatsApp.");
            }
            
        } finally {
            esconderLoading();
            globalMU.unblockUI();
        }
    };

    const obterStatusWhatsappVendedor = async (): Promise<StatusWhatsappResponse> => {
        try {
            const statusVendedor =
                await microuniversoApi.Whatsapp.obterStatusWhatsappVendedor(
                    props.vendedorAutenticado?.Codigo
                );
            setStatusSessaoVendedor(statusVendedor);

            return statusVendedor;
        } catch (error) {
            globalMU.showErrorMessage(((error as ErroDaApiEnterprise)?.mensagem ?? "Erro desconhecido."));
        }
    };
    const obterNumeroWhatsappVendedor = async () => {
        try {
            const numeroConfigurado =
                await microuniversoApi.Whatsapp.obterNumeroWhatsappVendedor(
                    props.vendedorAutenticado?.Codigo
                );
            setNumeroSincronizadoWhatsappVendedor(String(numeroConfigurado) ?? "");
        } catch (error) {
;
            console.error(
                "Erro ao obter número do WhatsApp do vendedor:",
                error
            );
        }
    };
    const VersaoMinimaApiEnterprise = (versao: string, versaoMinima: string ):boolean => {
        return converterVersaoParaNumero(versao) >=
            converterVersaoParaNumero(versaoMinima);
    }
    const obterInformacoesWhatsappVendedor = async () => {
        let versao: string = "";
        try {
            mostrarLoading();
            globalMU.blockUI();
            versao = await microuniversoApi.Comum.versaoApiEnterprise();
            setVersaoApiEnterprise(versao);
            
        if (
            VersaoMinimaApiEnterprise(versao, "4.5.2") &&
            valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString() &&
            valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_VENDEDOR") == "S"
        ) {
            const statusVendedor = await obterStatusWhatsappVendedor();
            setStatusSessaoVendedor(statusVendedor);

            if (statusVendedor.statusSessao == "CONFIGURADO") {
                await obterNumeroWhatsappVendedor();
            }
            else {      
                setRemetenteWhatsapp("padrao");
                globalMU.sessionStorage.setData(
                    "remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo, "padrao"
                );
            }
        }

        } catch (error) {
            globalMU.showErrorMessage(((error as ErroDaApiEnterprise)?.mensagem ?? "Erro desconhecido."));
        }
        finally {
            esconderLoading();
            globalMU.unblockUI();
           
        }

    };
    const obterRemetenteSessionStorage = () => {
        const remetenteSessionStorage: RemetenteWhatsapp = (
                    (globalMU.sessionStorage.getData("remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo) || "")
                        .replace(/[^a-zA-Z]/g, "")
                        .toLowerCase()
                ) as RemetenteWhatsapp;
                // breakdown each clause of the IF
              
                if (
                    VersaoMinimaApiEnterprise(versaoApiEnterprise, "4.5.2") &&
                    valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString() &&
                    valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_VENDEDOR") == "S"
                ) {

                  
                    setRemetenteWhatsapp(
                        remetenteSessionStorage || "padrao"
                        );
                }
                
                else {
                    setRemetenteWhatsapp("padrao");
                }
        }

    const buscarDadosEnviarWhatsapp = async (
        identificadorOrcamento: number,
        dadosEnviarWhatsappLocal?: RespostaModalEnviarEmail
    ) => {
        if (props.exibirModalWhatsapp == true) {
            globalMU.blockUI();
            mostrarLoading();
            try {


                if (
                    dadosEnviarWhatsappLocal &&
                    dadosEnviarWhatsappLocal.Anexos &&
                    dadosEnviarWhatsappLocal.Anexos.length > 0
                ) {
                    setUrlTemplate(
                        montarUrl(
                            props.template.Url,
                            props.parametrosTemplate,
                            dadosEnviarWhatsappLocal?.Anexos[0]?.UrlDownload
                        )
                    );
                }
                const vendedor: Vendedor =
                    (await microuniversoApi.Vendedor.ObterVendedorAutenticado()) ??
                    props.vendedor;
                setVendedorAutenticado(vendedor);

                 const remetenteSessionStorage: RemetenteWhatsapp = (
                    (globalMU.sessionStorage.getData("remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo) || "")
                        .replace(/[^a-zA-Z]/g, "")
                        .toLowerCase()
                ) as RemetenteWhatsapp;    

                
                const remetenteReal = globalMU.isNotNullOrEmpty(remetenteSessionStorage) ? remetenteSessionStorage : remetenteWhatsapp;

              
                setListaTelefoneCopia(
                    props.vendedorAutenticado && remetenteReal == "padrao" && props.vendedorAutenticado?.Whatsapp ? props.vendedorAutenticado?.Whatsapp : undefined
                );
                const dadosModificados: RespostaModalEnviarEmail = {
                    ...dadosEnviarWhatsappLocal,
                    ListaTelefoneCopia: vendedor && remetenteReal != "vendedor" && vendedor?.Whatsapp ? vendedor?.Whatsapp : null,
                    Mensagem: dadosEnviarWhatsappLocal.Mensagem?.replace(
                        "[NUMEROWHATSAPPVENDEDOR]",
                        props.vendedorAutenticado?.Whatsapp ?? "[NÃO DEFINIDO]"
                    ),
                };
                setDadosEnviarWhatsapp(dadosModificados);

             
            } catch (error) {
                globalMU.showErrorMessage(((error as ErroDaApiEnterprise)?.mensagem ?? "Erro desconhecido."));
              
            }
            finally{
                esconderLoading();
                globalMU.unblockUI();
                
            }
           
        }
    };

    const validarTelefoneComDDI = (telefone: string) => {
        if (!telefone) return false;
        const numero = telefone.replace(/\D/g, ""); // remove todos os caracteres não numéricos
        const comecaCom55 = numero.startsWith("55");
        return comecaCom55
            ? numero.length >= 12 && numero.length <= 15
            : numero.length >= 10 && numero.length <= 15;
    };

    const removerStringsVazias = (stringArray: string[]) => {
        if (!Array.isArray(stringArray)) return [];
        return stringArray.filter((item) => item.trim() !== "");
    };
    const formatarListaTelefoneCopias = (telefone: string) => {
        if (!telefone) return "";
        return telefone.replace(/[^\d,]/g, "");
    };

    const EnviarWhatsapp = async (dados: payloadEnviarWhatsapp) => {
        try {
            mostrarLoading();
            if (
                globalMU.isNull(dados.Telefone) ||
                dados.Telefone === "" ||
                !validarTelefoneComDDI(dados.Telefone)
            ) {
                globalMU.showErrorMessage(
                    "Erro nos dados fornecidos: Telefone invalido."
                );
                return;
            }
            if (listaAnexos.length > 0) {
                var formData = new FormData();
                for (let i: number = 0; i < listaAnexos.length; i++) {
                    formData.append(
                        "Anexo" + (i + 1),
                        listaAnexos[i],
                        listaAnexos[i].name
                    );
                }
                var anexoResponse: anexosEnviar[] = await enviarAnexo(formData);
            }

            const token = globalMU.token();

            let anexos: anexosEnviar[] = dadosEnviarWhatsapp.Anexos.map(
                (anexo) => {
                    return {
                        name: anexo.NomeArquivo,
                        url: montarUrl(
                            props.template.Url,
                            props.parametrosTemplate,
                            anexo.UrlDownload
                        ),
                        anexado: anexo.Anexado,
                        NomeArquivo: anexo.NomeArquivo,
                        Principal: anexo.Principal,
                        UrlDownload: montarUrl(
                            props.template.Url,
                            props.parametrosTemplate,
                            anexo.UrlDownload
                        ),
                    };
                }
            );

            const ListaTelefoneCopiaPreenchida: string[] =
                removerStringsVazias(
                    formatarListaTelefoneCopias(
                        ListaTelefoneCopia
                    ).split(",")
                ) || [];

            const payload: DadosEnviarWhatsapp = {
                telefone: dados.Telefone?.replace(/\D/g, ""),
                mensagem: dados?.Mensagem,
                anexos: globalMU.isNullOrEmpty(anexoResponse)
                    ? anexos
                    : anexos.concat(anexoResponse),
                template: props.template,
                token: token,
                numeroPedido: dadosEnviarWhatsapp.NumeroPedido,
                ListaTelefoneCopia:
                    ListaTelefoneCopiaPreenchida &&
                    ListaTelefoneCopiaPreenchida.length > 0
                        ? ListaTelefoneCopiaPreenchida
                        : undefined,
            };

            globalMU.blockUI();
            let response: EnviarWhatsappOutput = {
                Mensagem:
                    "Não Foi Possivel Enviar O Whatsapp.Erro Desconhecido.",
                Status: false,
            };
            const anexosEnviarWhatsapp = await microuniversoApi.Comum.ObterAnexos(payload);

            const payloadEnviarWhatsapp: DadosEnviarWhatsappMuWhatsappApi =
                {
                    mensagem: payload.mensagem,
                    anexos: anexosEnviarWhatsapp,
                    identificadorTipoMensagem: dadosEnviarWhatsapp.NumeroPedido,
                    telefone: payload.telefone,
                    tipoMensagem: "ORCAMENTO",
                    ListaTelefoneCopia: payload.ListaTelefoneCopia,
                };

            if (remetenteWhatsapp == "vendedor" && globalMU.isNullOrEmpty(numeroSincronizadoWhatsappVendedor)) {
                globalMU.showWarnMessage(
                    "É necessário configurar o WhatsApp do vendedor antes de enviar o WhatsApp."
                );
                setAbrirModalConfigurarWhatsapp(true);
                return;
            }
            if (remetenteWhatsapp == "vendedor" && numeroSincronizadoWhatsappVendedor && valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString() && valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_VENDEDOR") == "S") {
                response = await microuniversoApi.Whatsapp.enviarWhatsappVendedor(payloadEnviarWhatsapp,props.vendedorAutenticado?.Codigo);
            } 
            else if(remetenteWhatsapp == "padrao" && valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString() ) {
                if(valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_FILIAL") == "S" ) {
                    response = await microuniversoApi.Whatsapp.enviarWhatsappFilial(payloadEnviarWhatsapp, props.vendedorAutenticado?.CodigoFilial);
                }
                else {
                    response = await microuniversoApi.Whatsapp.enviarWhatsappSessaoPadrao(payloadEnviarWhatsapp);
                }
            }
            else {
                response = await microuniversoApi.Comum.EnviarWhatsapp(payloadEnviarWhatsapp);
            }
           
            props.onClose();
            globalMU.showSuccessMessage(response?.Mensagem ?? (response as any)?.mensagem);
        } catch (erro) {
            globalMU.showErrorMessage(erro?.Error ?? erro?.ExceptionMessage ?? erro?.mensagem ?? 'Ocorreu um erro desconhecido ao enviar o WhatsApp!');
            props.onClose();

        } finally {
            esconderLoading();
            globalMU.unblockUI();
        }
    };
    const enviarAnexo = async (binario): Promise<anexosEnviar[]> => {
        try {
            globalMU.blockUI();
            return await microuniversoApi.Seguranca.enviarAnexos(
                globalMU.token(),
                binario
            );
        } catch (erro) {
            tratamentoErroPadrao(erro);
        } finally {
            globalMU.unblockUI();
        }
    };
    const AnexarDocumentos = (event) => {
        if (event.target.files[0] && event.target.files[0].name) {
            setListaAnexos((current) => [...current, event.target.files[0]]);
        }
    };
    const RemoverAnexo = (AnexoRemovido, pos) => {
        setListaAnexos((current) =>
            current.filter(
                (anexo, index) => anexo !== AnexoRemovido || index !== pos
            )
        );
    };

    const atualizarParametros = async () => {
        try {
            const [parametrosFilial, parametrosEmpresa] = await Promise.all([
                obterParametrosPorOidItem({
                    nomes: ["METODO_ENVIO_MENSAGEM_WHATSAPP"],
                    oidItem: props.vendedorAutenticado?.OidFilial ?? orcamento.OidFilialOrcamento,
                }),
                obterParametros({
                    nomes: [
                        "HABILITAR_WHATSAPP_POR_FILIAL",
                        "HABILITAR_WHATSAPP_POR_VENDEDOR",
                    ],
                })
            ]);
            setParametrosPorFilial(parametrosFilial);
            setParametrosPorEmpresa(parametrosEmpresa);
        } catch (e) {
            tratamentoErroPadrao(e);
        }
    };
    const valorParametroPorFilial = (nome: string) =>
        parametrosPorFilial.find((p) => p.Nome == nome)?.Valor;
    const valorParametroPorEmpresa = (nome: string) =>
        parametrosPorEmpresa.find((p) => p.Nome == nome)?.Valor;

    const handleAlterarRemetente = (
        remetente: RemetenteWhatsapp
    ) => {


        setRemetenteWhatsapp(remetente);
        globalMU.sessionStorage.setData(
            "remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo, remetente
        );
       const ListaTelefoneCopiaPreenchida: string[] = removerStringsVazias(formatarListaTelefoneCopias(ListaTelefoneCopia).split(",")) || [];
       let numeroCadastradoVendedor = props.vendedorAutenticado?.Whatsapp?.replace("+", "");

        if(remetente == "padrao" &&  props.vendedorAutenticado?.Whatsapp) {
            
            if(!ListaTelefoneCopiaPreenchida.includes(numeroCadastradoVendedor)) {
                if(numeroCadastradoVendedor) {
                    setListaTelefoneCopia((current) => {
                        if(!current || current.trim() == "") return numeroCadastradoVendedor;

                        return current + "," + numeroCadastradoVendedor
                    });
                }
            }
        }
        if (remetente == "vendedor" && props.vendedorAutenticado?.Whatsapp) {
            if(ListaTelefoneCopiaPreenchida.length > 0 && ListaTelefoneCopiaPreenchida.includes(numeroCadastradoVendedor)) {
               const arrayTelefonesSemVendedor = ListaTelefoneCopiaPreenchida.filter((telefone) => telefone !== numeroCadastradoVendedor);
               setListaTelefoneCopia(arrayTelefonesSemVendedor.join(","));
            }
        }
        if (remetente == "vendedor" && !numeroSincronizadoWhatsappVendedor) {
            setAbrirModalConfigurarWhatsapp(true);
        }
    };

    useEffect(() => {
        if (props.exibirModalWhatsapp && props.dadosEnvio) {
            buscarDadosEnviarWhatsapp(props.idOrcamento, props.dadosEnvio);
        }
    }, [props.exibirModalWhatsapp, props.dadosEnvio]);

    useEffect(() => {
        if (
            props.vendedorAutenticado &&
            props.vendedorAutenticado.Codigo &&
            !abrirModalConfigurarWhatsapp
        ) {
            obterInformacoesWhatsappVendedor();
        }
    }, [props.vendedorAutenticado, abrirModalConfigurarWhatsapp, parametrosPorFilial, parametrosPorEmpresa]);

    useEffect(() => {}, [numeroSincronizadoWhatsappVendedor]);

    useEffect(() => {
        atualizarParametros();
    }, []);

    const checarDisponibilidadeWhatsappPadrao = (): boolean => {
        if (valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_FILIAL") == "S"){
            return statusSessaoFilial?.statusSessao === "CONFIGURADO" || statusSessaoPadrao?.statusSessao === "CONFIGURADO";
        }
            
        
        return statusSessaoPadrao?.statusSessao === "CONFIGURADO";
    }

    const obterStatusWhatsappSessaoFilial = async () => {
        try{
            const statusSessaoFilial: StatusWhatsappResponse = await microuniversoApi.Whatsapp.obterStatusWhatsappSessaoFilial(props.vendedorAutenticado.CodigoFilial);
            setStatusSessaoFilial(statusSessaoFilial);
        }
        catch{}
    }
    const obterStatusWhatsappSessaoPadrao = async () => {
        try{
            const statusSessaoPadrao: StatusWhatsappResponse = await microuniversoApi.Whatsapp.obterStatusWhatsappSessaoPadrao();
            setStatusSessaoPadrao(statusSessaoPadrao);
        }
        catch{}
    }
    const handleOnCloseModalConfigurarWhatsapp = async () => {
        setAbrirModalConfigurarWhatsapp(false);
        try{
            const statusVendedor = await obterStatusWhatsappVendedor();
            console.log("status apos fechar modal configurar", statusVendedor);
            if(statusVendedor && statusVendedor.statusSessao == "CONFIGURADO") {
                 setRemetenteWhatsapp("vendedor");
                globalMU.sessionStorage.setData(
                    "remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo, "vendedor"
                );
            }
            else{
                setRemetenteWhatsapp("padrao");
                globalMU.sessionStorage.setData(
                    "remetenteWhatsapp_" + props.vendedorAutenticado?.Codigo, "padrao"
                );
            
                const ListaTelefoneCopiaPreenchida: string[] = removerStringsVazias(formatarListaTelefoneCopias(ListaTelefoneCopia).split(",")) || [];
                if(!ListaTelefoneCopiaPreenchida.includes(props.vendedorAutenticado?.Whatsapp)) {
                    if(props.vendedorAutenticado?.Whatsapp) {
                        setListaTelefoneCopia((current) => {
                            if(!current || current.trim() == "") return props.vendedorAutenticado?.Whatsapp;

                            return current + "," + props.vendedorAutenticado?.Whatsapp
                        });
                    }
                }
            }
           
        } 
        catch{}
    };

    useEffect(() => {
        if (props.vendedorAutenticado && props.vendedorAutenticado.Codigo && versaoApiEnterprise && parametrosPorEmpresa.length > 0) {
            obterRemetenteSessionStorage();
        }
            
    }, [props.vendedorAutenticado, versaoApiEnterprise, parametrosPorEmpresa]);

    useEffect(() => {
        if (valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString()) {
            obterStatusWhatsappSessaoPadrao();
            obterStatusWhatsappSessaoFilial();
        }
    }, [parametrosPorFilial]);


    return (
        <>
            <Loading carregandoConteudo={semaforoLoading > 0} />

            {props.exibirModalWhatsapp && abrirModalConfigurarWhatsapp && (
                <ModalConfigurarWhatsappContainer
                    exibirModalWhatsapp={
                        abrirModalConfigurarWhatsapp &&
                        props.exibirModalWhatsapp
                    }
                    codigoVendedor={props.vendedorAutenticado?.Codigo}
                    onApagarSessao={(inibirMensagemDeErro:boolean) => removerWhatsappVendedor(inibirMensagemDeErro)}
                    onClose={handleOnCloseModalConfigurarWhatsapp}
                    onConfigurado={ () => { setAbrirModalConfigurarWhatsapp(false); }}
                    onObterStatus={obterStatusWhatsappVendedor}
                />
            )}

            {props.exibirModalWhatsapp && (
                <ModalEnviarWhatsapp
                    RespostaModalEnviarWhatsapp={dadosEnviarWhatsapp}
                    Anexos={listaAnexos}
                    urlTemplate={urlTemplate}
                    PermitidoAnexarEmail={props.permitidoAnexar}
                    PermitidoAlterarAssunto={props.permitidoAlterarAssunto}
                    PermitidoCopiaOculta={props.permitidoCopiaOculta}
                    PermitidoCopia={props.permitidoCopia}
                    PermitidoAlterarMensagem={props.permitidoAlterarMensagem}
                    onClose={props.onClose}
                    onEnviarWhatsapp={EnviarWhatsapp}
                    onAnexar={AnexarDocumentos}
                    onRemoverAnexo={RemoverAnexo}
                    remetente={remetenteWhatsapp}
                    ListaTelefoneCopia={ListaTelefoneCopia}
                    whatsappPadraoDesconfigurado={!checarDisponibilidadeWhatsappPadrao()}
                    fallbackWhatsappPadrao={statusSessaoPadrao?.statusSessao == "CONFIGURADO" && statusSessaoFilial?.statusSessao != "CONFIGURADO" && parametrosPorEmpresa.length > 0 && valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_FILIAL") == "S"}
                    WhatsappCadastradoVendedor={props.vendedorAutenticado?.Whatsapp}
                    exibirEscolhaRemetente={
                        VersaoMinimaApiEnterprise(versaoApiEnterprise, "4.5.2") &&
                        valorParametroPorFilial("METODO_ENVIO_MENSAGEM_WHATSAPP") == EnumTiposMuWhatsapp.API.toString() &&
                        valorParametroPorEmpresa("HABILITAR_WHATSAPP_POR_VENDEDOR") == "S"
                    }
                    numeroSincronizadoWhatsappVendedor={numeroSincronizadoWhatsappVendedor}
                    alterarRemetenteBloqueado={
                        !VersaoMinimaApiEnterprise(versaoApiEnterprise, "4.5.2")
                    }
                    onRemoverWhatsappVendedor={removerWhatsappVendedor}
                    onChangeRemetente={(remetente: RemetenteWhatsapp) => {

                        handleAlterarRemetente(remetente);
                    }}
                    onAlterarTelefoneCopia={(telefoneCopia: string) => {
                        setListaTelefoneCopia(telefoneCopia);
                    }}
                />
            )}
        </>
    );
});

